.container {
  display: inline-flex;
}

.standardInput {
  width: unset !important;
}
